import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "fixed z-10 inset-0 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black opacity-75 transition-opacity" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_5 = { class: "inline-block align-bottom bg-white rounded-sm px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 border-2 border-gray-500 rounded-md shadow-xl" }
const _hoisted_6 = { class: "text-center sm:text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", {
  class: "text-lg font-russo leading-6 pb-2 font-medium text-gray-900",
  id: "modal-title"
}, " SUBSCRIBE & SAVE ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, " Sign up now, save time and money by receiving an e-mail with exclusive products coming up in store! ", -1)
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "pb-3" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-lg my-4 text-green-500 bg-green-100 border-2 rounded border-green-500" }
const _hoisted_14 = { class: "m-2" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-lg my-4 text-red-500" }
const _hoisted_17 = { class: "mx-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-900",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  type: "text",
                  placeholder: "Enter your name...",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-900",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  type: "text",
                  placeholder: "Enter email...",
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  type: "button",
                  class: "w-1/2 justify-center text-gray-400 hover:text-gray-800"
                }, " Close "),
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args))),
                  class: "mt-3 inline-flex justify-center w-1/2 rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
                }, " Subscribe ")
              ]),
              (_ctx.isSubscribed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.message), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.message), 1)
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}